import "antd/dist/antd.css";
import cookie from "js-cookie";
// import { message } from "antd";
import { connect } from "react-redux";
import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";

import {
  actionGetProfile,
  actionGeneralInfo,
  actionGetListBank,
  actionHideLoading,
  actionShowLoading,
} from "./features/system/actions";
import { TOKEN } from "./utils/constants/constant";
// import { getTokenForSystem } from "./features/login/actions";
import LocaleProvider from "./utils/localeProvider/LocaleProvider";

import Routes from "./Routes";

import "./App.scss";

function App(props) {
  useEffect(() => {
    props.actionGeneralInfo();

    if (cookie.get(TOKEN)) {
      props.actionGetProfile();
      props.actionGetListBank();
    }
    // const urlParams = new URLSearchParams(window.location.search);
    // const loginToken = urlParams.get("login_token");
    // if (loginToken) {
    //   getToken(loginToken);
    // }
    // eslint-disable-next-line
  }, [cookie.get(TOKEN)]);

  // const getToken = async (loginToken) => {
  //   try {
  //     props.actionShowLoading();
  //     const { data } = await getTokenForSystem({
  //       accessToken: loginToken,
  //       providerName: "mytour",
  //       source: "affiliation",
  //     });
  //     if (data.code === 200) {
  //       cookie.set(TOKEN, data.data.token, { expires: 182 });
  //       window.location.href = "/dashboard";
  //       props.actionGetProfile();
  //     } else {
  //       data?.message && message.error(data?.message);
  //     }
  //   } catch (error) {
  //   } finally {
  //     props.actionHideLoading();
  //   }
  // };

  return (
    <LocaleProvider>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </LocaleProvider>
  );
}

export default connect(() => ({}), {
  actionGetProfile,
  actionGeneralInfo,
  actionGetListBank,
  actionHideLoading,
  actionShowLoading,
})(App);
